import {Component, effect, inject, signal} from '@angular/core';
import {NgClass} from "@angular/common";
import {AssetComponent} from "src/app/presentation/common/asset.component";
import {DataSubscriptionService} from "src/app/infrastructure/data-subscription.service";
import {
  ProximitySamplePointButtonComponent
} from "src/app/presentation/main-view/information-center/proximity-sample-points/proximity-sample-point-button/proximity-sample-point-button.component";
import {DataSynchronisationService} from "src/app/infrastructure/data-synchronisation.service";
import {ViewportService} from "src/app/infrastructure/viewport.service";
import {BluetoothSvgComponent, Status} from "src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component";
import {Device, FixedSamplePoint} from "src/app/infrastructure/moovement-api/models/asset";
import {DeviceStore} from 'src/app/domain/devices/device.store';
import {
  UnassignedBluetoothProximitySensorButtonComponent
} from "src/app/presentation/main-view/information-center/proximity-sample-points/unassigned-bluetooth-proximity-sensor-button/unassigned-bluetooth-proximity-sensor-button.component";
import {FixedSamplePointsStore} from 'src/app/domain/assets/fixed-sample-points/fixed-sample-points.store';
import {GenericButtonComponent} from "src/app/presentation/common/generic-button/generic-button.component";
import {ActionButtonComponent} from "src/app/presentation/common/action-button/action-button.component";
import {OverviewApiClient} from "src/app/infrastructure/moovement-api/web-api/overview.api-client";
import {FarmStore} from "src/app/domain/assets/farm/farm.store";


@Component({
  selector: 'app-proximity-sample-points',
  imports: [
    ProximitySamplePointButtonComponent,
    NgClass,
    BluetoothSvgComponent,
    UnassignedBluetoothProximitySensorButtonComponent,
    GenericButtonComponent,
    ActionButtonComponent
  ],
  templateUrl: './proximity-sample-points.component.html',
  styleUrl: './proximity-sample-points.component.css'
})
export class ProximitySamplePointsComponent extends AssetComponent {

  private farmStore = inject(FarmStore);

  filteredProximitySamplePoints = signal<FixedSamplePoint[]>([]);
  filteredUnassignedBluetoothProximitySensors = signal<Device[]>([]);

  Status = Status;

  fixedSamplePointsStore = inject(FixedSamplePointsStore);

  private devicesStore = inject(DeviceStore);
  private filter = signal<string | undefined>(undefined);

  constructor(dataSynchronisationService: DataSynchronisationService, dataSubscriptionService: DataSubscriptionService, viewportService: ViewportService, protected overviewService: OverviewApiClient) {
    super(dataSynchronisationService, dataSubscriptionService, viewportService);
    effect(() => {
      const loadingProximitySamplePoints = this.fixedSamplePointsStore.loading();
      const loadingDevices = this.devicesStore.loading();

      this.loading = loadingProximitySamplePoints || loadingDevices;
    });

    effect(() => {
      const filter = this.filter();
      if (!filter) {
        this.filteredProximitySamplePoints.set(this.fixedSamplePointsStore.proximitySamplePoints());
        this.filteredUnassignedBluetoothProximitySensors.set(this.devicesStore.unassignedBluetoothProximitySensors());
        return;
      }

      const filteredProximitySamplePoints = this.fixedSamplePointsStore.proximitySamplePoints()
        .filter(proximitySamplePoint => {
          return proximitySamplePoint?.id?.toLowerCase().includes(filter)
            || proximitySamplePoint?.name?.toLowerCase().includes(filter)
        });
      this.filteredProximitySamplePoints.set(filteredProximitySamplePoints);

      const filteredUnassignedProximitySamplePoints = this.devicesStore.unassignedBluetoothProximitySensors()
        .filter(device => {
          return device.id.toLowerCase().includes(filter)
        });
      this.filteredUnassignedBluetoothProximitySensors.set(filteredUnassignedProximitySamplePoints);
    });
  }

  filterResults(input: any) {
    if (!input.value) {
      this.filter.set(undefined);
      return;
    }

    const value = (input.value as string).toLowerCase();
    this.filter.set(value);
  }

  protected downloadPDF() {
    this.overviewService.download({
      farmId: this.farmStore.farm()?.id || '',
      capabilities: ['Proximity', 'ProximityDeviceArrival']
    }).subscribe({
      next: blob => {
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = 'proximity-overview.pdf';
        anchor.click();
        window.URL.revokeObjectURL(url);
      }
    })
  }
}
